// extracted by css-extract-rspack-plugin
export default {"container":"ActionBar-module__container__Sx4bH","legacyDensityToggle":"ActionBar-module__legacyDensityToggle__u_t1j"};